import BaseRights from "../BaseRights";

export default class ReportFilterRights extends BaseRights {
    constructor() {
        super(...arguments);

        this.reportId = `${this.params.table}.${this.params.form}.filters`;
        this.filterRights = [];
        this.setFilterRights();
    }

    setFilterRights() {
        for (const rightString in this.manager.rights.view) {
            if ( rightString.includes(this.reportId) ) {
                this.filterRights.push(rightString);
            }
        }
    }

    isNoRights() {
        let noRights = system.user.isAdmin() ? false : true;

        if ( this.filterRights.length > 0 ) {
            noRights = false;
        }

        return noRights;
    }

    getUserAndDepartmentsUsersIds() {
        const userAndDepartmentsUsersIds = [];
        let isRestricted = system.user.isAdmin() ? false : true;

        for (const rightString of this.filterRights) {
            if ( rightString === this.reportId || rightString.includes("other") ) {
                isRestricted = false;
                userAndDepartmentsUsersIds.length = 0;
                break;
            }
            if ( rightString.includes("owner") ) {
                userAndDepartmentsUsersIds.push(+system.user.id);
            }
            if ( rightString.includes("department") ) {
                const departmentsUsers = system.user.model.get("DEPARTMENTS_USERS") || [];
                departmentsUsers.forEach((departmentUserId) => {
                    if ( +departmentUserId > 0 ) {
                        userAndDepartmentsUsersIds.push(+departmentUserId);
                    }
                });
            }
        }

        if ( this.isNoRights() || (isRestricted && userAndDepartmentsUsersIds.length === 0) ) {
            userAndDepartmentsUsersIds.push(0);
        }

        return userAndDepartmentsUsersIds;
    }
}
